var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBoxRedirect(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 331,
    height: 405,
    viewBox: "0 0 331 405",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 149,
    width: 7.5,
    height: 172,
    rx: 3.75,
    fill: "#909090"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 322,
    y: 150,
    width: 7.5,
    height: 171,
    rx: 3.75,
    fill: "#909090"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 161,
    y: 231,
    width: 7.5,
    height: 170,
    rx: 3.75,
    fill: "#909090"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 7.5,
    height: 187,
    rx: 3.75,
    transform: "matrix(-0.454073 -0.890965 -0.890965 0.454073 330.243 319.128)",
    fill: "#909090"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    y: 155.128,
    width: 7.5,
    height: 187,
    rx: 3.75,
    transform: "rotate(-62.9947 0 155.128)",
    fill: "#909090"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 3.7915,
    y: 157.337,
    width: 7.5,
    height: 141.983,
    rx: 3.75,
    transform: "rotate(-118.291 3.7915 157.337)",
    fill: "#909090"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 7.5,
    height: 146.07,
    rx: 3.75,
    transform: "matrix(0.473948 -0.880553 -0.880553 -0.473948 326.969 158.438)",
    fill: "#909090"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 7.5,
    height: 187,
    rx: 3.75,
    transform: "matrix(-0.454073 -0.890965 -0.890965 0.454073 330.243 155.128)",
    fill: "#909090"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    y: 319.128,
    width: 7.5,
    height: 187,
    rx: 3.75,
    transform: "rotate(-62.9947 0 319.128)",
    fill: "#909090"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    y: 155.128,
    width: 7.5,
    height: 187,
    rx: 3.75,
    transform: "rotate(-62.9947 0 155.128)",
    fill: "#909090"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M162.343 5.09311C162.343 3.02204 164.022 1.34311 166.093 1.34311C168.164 1.34311 169.843 3.02204 169.843 5.09311V147.593C169.843 149.664 168.164 151.343 166.093 151.343C164.022 151.343 162.343 149.664 162.343 147.593V5.09311Z",
    fill: "#909090"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M163.806 8.09933C162.256 6.72513 162.114 4.35501 163.488 2.80554C164.862 1.25606 167.232 1.11397 168.782 2.48818L223.023 50.5938C224.573 51.968 224.715 54.3381 223.34 55.8876C221.966 57.437 219.596 57.5791 218.047 56.2049L163.806 8.09933Z",
    fill: "#909090"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M168.023 8.09933C169.573 6.72513 169.715 4.35501 168.34 2.80554C166.966 1.25606 164.596 1.11397 163.047 2.48818L108.805 50.5938C107.256 51.968 107.114 54.3381 108.488 55.8876C109.862 57.437 112.232 57.5791 113.782 56.2049L168.023 8.09933Z",
    fill: "#909090"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxRedirect);
export default __webpack_public_path__ + "static/media/box-redirect.233a659729919eec2e5843ce2320d500.svg";
export { ForwardRef as ReactComponent };